import { handleActions } from 'redux-actions';
import i18next from 'i18next';
import { showError } from '../errors/ErrorsActions';
import { isNotificationError } from '../errors/ErrorsService';
import * as actions from './NotificationsActions';
import {
    addAndRemoveOldNotification,
    convertErrorToNotification,
    removeNotification
} from './NotificationsService';
import { NotificationVariant } from '../../models/Notification';
import { NotificationsState } from './NotificationsState';

const defaultState: NotificationsState = {
    notifications: []
};

const NotificationsReducer = handleActions<NotificationsState, any>(
    {
        [actions.showNotification.toString()]: (state, action) => ({
            ...state,
            notifications: addAndRemoveOldNotification(
                state.notifications,
                action.payload.notification
            )
        }),
        [actions.hideNotification.toString()]: (state, action) => ({
            ...state,
            notifications: removeNotification(
                state.notifications,
                action.payload.id
            )
        }),
        [showError.toString()]: (state, action) => {
            const error = action.payload.error;

            if (error?.status === 403) {
                return {
                    ...state,
                    notifications: addAndRemoveOldNotification(
                        state.notifications,
                        {
                            id: 'sunset-read-only-error',
                            text: i18next.t(
                                'apiError.sunsetReadOnlyApplication'
                            ),
                            variant: NotificationVariant.Error
                        }
                    )
                };
            }

            if (isNotificationError(error)) {
                return {
                    ...state,
                    notifications: addAndRemoveOldNotification(
                        state.notifications,
                        convertErrorToNotification(error)
                    )
                };
            }
            return state;
        }
    },
    defaultState
);

export { NotificationsReducer };
